<script>
    import { get_attribute_label, get_attribute_name, get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724693';
    import { attribute_exists, get_list, get_value, transform_to } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/tab/attribute_helper.js?1733898724693';

    export let product;
    export let attribute;
    export let unit = undefined;
    export let value = undefined;
    export let transform = undefined;
    export let digits = 2;
    export let show_label = true;

    const locale = getStack('locale');

    $: exists = attribute_exists(product, attribute);

    $: is_simple_attribute = typeof attribute == 'string' && get_attribute_value(product, attribute);
    $: list = get_list(product, attribute);
</script>

{#if exists}
    {#if is_simple_attribute}
            {#if show_label}
                <div class="label">{get_attribute_label(product, attribute)}:</div>
            {/if}
            {#if value}
            <div class="value">{transform_to(value, transform, locale, digits)}</div>
            {:else}
            <div class="value">{transform_to(get_attribute_name(product, attribute), transform, locale, digits)}</div>
            {/if}
            {#if unit} <div class="label">Unit:</div><div class="value">{window.__('unit.' + unit)}</div>{/if}
    {:else if list}
        <div>
            <ul>
                {#each list as value}
                    <li>{value}</li>
                {/each}
            </ul>
        </div>
    {:else if typeof attribute == 'object' && attribute.attribute}
        <svelte:self {product} {...attribute} {show_label} value={get_value(product, attribute)} />
    {/if}
{/if}


<style>
    .label{
        font-weight: 800;
    }
</style>